
import React, { useState } from 'react';
import UI from "components/UI";
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/main/Breadcrumb';
import UIInput from 'components/input/input';
import Button from 'components/buttons/';
import useToggleState from 'components/hooks/useToggleState';
import ModalPopup from 'components/modal/';
import CommonUtil from 'utils/CommonUtil';
import StringUtil from 'utils/StringUtil';
import UICheckbox from 'components/checkbox/UICheckbox';
import UIRadio from 'components/radios/UIRadio';
import UIUtils from "utils/UIUtils";
import message from "common/message/source/MessageSource";
import UISelect from 'components/selectbox/UISelect';
import codeDataStore from "common/codedata/store/CodeDataStore";
import { CodeData } from "common/codedata/source/CodeDataSource";
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";
import PageLoading from "../../../../components/loading";
import UITextArea from 'components/atoms/textarea/UITextArea';
import TbComPerson from "../../../../domain/main/com/person/TbComPerson";
import DateUtils from 'utils/DateUtil';

function ContentsContainer() {
	const modaladm2138 = useToggleState({});
	const [modaladm2138Open, setModaladm2138Open] = useState(false); //환수기업조회 팝업오픈여부
	const location = useLocation();
  	const receivedData = (location.state as any)?.data;
	const history = useHistory();
	let redeReqAmtListPopData = {};   //환수기업 내역등록 팝업
	let defaultRowCnt = 20;
	let totalRedeTskCnt:number = 0;
	let totalRedeReqAmtListCnt:number = 0;

	const [exempAmt,setExempAmt] = useState(0);
	const [exempReason,setExempReason] = useState('');
	const [payAmtSum,setPayAmtSum] = useState('');
	const [redeAmtSum,setRedeAmtSum] = useState('');

	const [redeReqNo, setRedeReqNo] = useState('');
	const [payReqNo, setPayReqNo] = useState('');
	const [tskReqNo, setTskReqNo] = useState('');
	const [tskReqModiSeq, setTskReqModiSeq] = useState('');

	const [redeDetail, setRedeDetail] = useState({});
	const [payDetail, setPayDetail] = useState({});
	const [tskDetail, setTskDetail] = useState({});
	const [memberDetail, setMemberDetail] = useState<TbComPerson>(new TbComPerson());

	//파일정보 선언 
	const [fileId, setFildId] = useState('');
	const [fileValueTemp, setFileValue] = useState(new TbComFile());
	const fileValue = React.useDeferredValue(fileValueTemp);
	const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);
	const [totalReqAmtListCnt,setTotalRedeReqAmtListCnt] = useState(0);
	const [loadFinish,setLoadFinish] = useState(false);

	//심사리스트
	const [judgeList, setJudgeList] = React.useState<any[]>([]);
	const [judgeReqList, setJudgeReqList] = React.useState<any[]>([]);

	//입출금 리스트 
	const [trdList, setTrdList] = React.useState<any[]>([]);


	//====== 그리드 공통 부 START
	var ib = ib||{};
	ib = {
		//시트 초기화 구문
		'init': {
			"RedeTskList": {  //지급과제조회
				"Cfg": {
					"SearchMode": 1,
					"PageLength": defaultRowCnt,
					"AutoRowHeight": 1,
					"InfoRowConfig": "0",
					"Alternate": "0"
				},
				"Cols": [
					{"Header": "NO", "Type": "Int",	"Name": "SEQ",					"RelWidth": 1,	"Align": "Center",	"CanEdit": 0},
					{"Header": "환수신청", "Type": "Html", "Name": "REDE_REQ_STS_NM", "RelWidth": 1.5, "Align": "Center", "CanEdit": "0",
						"Format": {
							'신청': '<label class="badge badge-22 blue">신청</label>',
							'접수완료': '<label class="badge badge-22 green">접수완료</label>',
							'수정요청': '<label class="badge badge-22 yellow">수정요청</label>',
							'반려': '<label class="badge badge-22 red">반려</label>',
							'심사완료': '<label class="badge badge-22 gray">심사완료</label>'
						}
					},
					{"Header": "과제명", "Type": "Text", "Name": "TSK_NM", "RelWidth": 3.5, "Align": "Left", "CanEdit": "0"},
					{"Header": "과제번호", "Type": "Text", "Name": "TSK_REQ_NO", "RelWidth": 1.5, "Align": "Center", "CanEdit": "0", "CustomFormat": "#-##-#####"},
					{"Header": "과제시작일","Type": "Date","Name": "TSK_ST_DATE","RelWidth": 1.5,"Align": "Center" ,"CanEdit": "0", "DataFormat": "yyyy-MM-dd"},
					{"Header": "과제종료일","Type": "Date","Name": "TSK_EN_DATE","RelWidth": 1.5,"Align": "Center" ,"CanEdit": "0", "DataFormat": "yyyy-MM-dd"},
					{"Header": "신청자","Type": "Text","Name": "PAY_REQ_USERNM","RelWidth": 1.5,"Align": "Center" ,"CanEdit": "0"},
					{"Header": "집행일자","Type": "Date","Name": "PAY_COMPL_DATE","RelWidth": 1.5,"Align": "Center" ,"CanEdit": "0", "DataFormat": "yyyy-MM-dd"},
					{"Header": "지금신청번호","Type": "Text","Name": "PAY_REQ_NO","RelWidth": 1.5,"Align": "Center" ,"CanEdit": "0"}
				]

			},
			"RedeReqAmtList": {  //환수기업조회 
				"Cfg": {
				    "SearchMode": 3,
					//"PageLength": 20,
					"AutoRowHeight": 1,
					"InfoRowConfig": "0",
					"Alternate":"0",
					"HeaderMerge": 6,
					"HeaderCheck": 1,
					"HeaderCheckMode": 1,
					"CanSort": 0,                 // 소팅옵션 off
					"ShowFilter": 1,             // 필터행 표시
					"dataMerge":1,
				},
				"Cols": [
					
					{"Header": ["환수기업 내역","지원기업"],"Type": "Text","Name": "SUPP_CORP_NM","RelWidth": 1.5,"Align": "Center" ,"CanEdit": 0},
					{"Header": ["환수기업 내역","사업자등록번호"],"Type": "Text","Name": "SUPP_BIZ_NO","RelWidth": 2,"Align": "Center","CanEdit": 0},
					{"Header": ["환수기업 내역","대표자명"],"Type": "Text","Name": "SUPP_CEO_NM","RelWidth": 2,"Align": "Center","CanEdit": 0},
					{"Header": ["환수기업 내역","지원금액(원)"],"Type": "Int","Name": "PAY_AMT","RelWidth": 2,"Align": "Right","CanEdit": 0},
					{"Header": ["환수기업 내역",{"Value": "환수금액(원)" ,"Color": "#FFDFDF"}],"Type": "Int","Name": "REDE_AMT","RelWidth": 2,"Align": "Right","CanEdit": 0},
					{"Header": ["환수기업 내역",{"Value": "환수 면제 금액(원)" ,"Color": "#FFDFDF"}],"Type": "Int","Name": "EXEMP_AMT","RelWidth": 2,"Align": "Right","CanEdit": 0, Visible : 0},
					{"Header": ["환수기업 내역",{"Value": "환수 면제 사유" ,"Color": "#FFDFDF"}],"Type": "Text","Name": "EXEMP_RSN","RelWidth": 2,"Align": "Center","CanEdit": 0, Visible : 0},
				
				]
				
			},
		},

		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
			

				var sheet = evtParam.sheet;
			    if(sheet.id === "RedeReqAmtList"){
					
					//@ts-ignore
					sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_CEO_NM", sheet.getRowById("Filter"), "SUPP_CEO_NM");
					//@ts-ignore
					sheet.setMergeRange( sheet.getRowById("HR1"), "PAY_AMT", sheet.getRowById("Filter"), "PAY_AMT");
					//@ts-ignore
					sheet.setMergeRange( sheet.getRowById("HR1"), "REDE_AMT", sheet.getRowById("Filter"), "REDE_AMT");
										//@ts-ignore
					sheet.setMergeRange( sheet.getRowById("HR1"), "EXEMP_AMT", sheet.getRowById("Filter"), "EXEMP_AMT");
					//@ts-ignore
					sheet.setMergeRange( sheet.getRowById("HR1"), "EXEMP_RSN", sheet.getRowById("Filter"), "EXEMP_RSN");
					
					getRedeReqAmtList('init');
					
					if(Number(getInfo('EXEMP_AMT','rede')) > 0){
						sheet.setAttribute(null, "EXEMP_AMT", "Visible", 1);
						sheet.setAttribute(null, "EXEMP_RSN", "Visible", 1);
					}
					
				}

			},
            //데이터 로딩 후 이벤트 처리
			onDataLoad:function (evtParam) {
				// 시트에 들어간 데이터가 파싱되어 로드된 후에 발생합니다. (데이터는 파싱되었으나 화면에 반영되는 렌더링 전입니다.)
				var sheet = evtParam.sheet;
				if(sheet.id === "RedeReqAmtList"){ //환수기업내역 

					//@ts-ignore
					var redeReqAmtListRows = sheet.getDataRows(); //RedeReqAmtList 시트 전체 데이터 조회
					
					let payAmtSum = 0;
					let redeAmtSum = 0;
					for(var i=0; i<redeReqAmtListRows.length; i++){
						payAmtSum += redeReqAmtListRows[i].PAY_AMT;
						redeAmtSum += redeReqAmtListRows[i].REDE_AMT;
					}

					setPayAmtSum(String(payAmtSum));
					setRedeAmtSum(String(redeAmtSum));
				}
			  },
		
			onBeforeDataLoad:function (evtParam) {
				// 조회 후 로딩 전 발생 이벤트
				var d = evtParam.data;
				var _data;

				let sliceData = [];
				// 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
				if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
					sliceData = d.slice(0, defaultRowCnt);
					_data = JSON.stringify(sliceData, null, 2);
					_data += _data.substring(0, _data.length - 1) + '...\n]';
				} else {
					_data = JSON.stringify(d, null, 2);
				}
			},
			onAfterGotoPage:function (evtParam) {

				var sheet = evtParam.sheet;
				if(sheet.id === "RedeReqAmtList"){  
					//@ts-ignore
					var page = RedeReqAmtList.getPageIndex(RedeReqAmtList.getFocusedPage()) + 1;
					//@ts-ignore
					if (currentPage != -1 && currentPage != page) {
						makePageIndex(page, "reqAmtList");
					}
				}

			}
		},
		

		//시트객체 생성
		'createRedeReqAmtList':function () {
			var options3 = this.init.RedeReqAmtList;
			options3.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'RedeReqAmtList', // 생성할 시트의 id
				el: 'RedeReqAmtListDiv', // 시트를 생성할 Dom 객체 및 id
				options: options3, // 생성될 시트의 속성
				data: redeReqAmtListPopData // 생성될 시트의 정적데이터
			});

			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//조회 데이터
		'data':[]
	}


	//====== 그리드 페이징 처리
	// @ts-ignore
	const makePageIndex = function (tp:number, divCd:string) {
		try {
			if (tp == null) {
				//@ts-ignore
				currentPage = -1;
				return;
			}
	
			// @ts-ignore
			currentPage = tp;
			// @ts-ignore
			let sr = 0; // 전체 조회 건수
			let page = 20;
			if(divCd =="reqAmtList"){
				// @ts-ignore
				if (document.getElementById('pageNaviRede').firstChild) {
					// @ts-ignore
					document.getElementById('pageNaviRede').removeChild(document.getElementById('pageNaviRede').firstChild);
				}
			   sr = totalRedeReqAmtListCnt;
			   // @ts-ignore
			   page = defaultRowCnt; // 레코드 수
			}
			let thispage = tp; // 현재 페이지
			let pagecnt = 5; // 한번에 표시할 페이지 개수
			let lastpage = Math.ceil(sr / page); // 마지막 페이지 인덱스
			let li, tt, a;
			let ul = document.createElement('DIV');
			// @ts-ignore
			ul.style.textAlign = 'center';
	
			let k = 1;
	
			if (thispage !== 1) {
			let ul_sub = document.createElement('DIV');
			ul_sub.className ="group";
			li = document.createElement('Button');
			li.className = 'item first';
			a = document.createElement('a');
			a.style.cursor = 'pointer';
			tt = document.createTextNode('<<');
			addEventHandler(li, 'click', pageMove, 1, divCd);
			a.appendChild(tt);
			li.appendChild(a);
			ul_sub.appendChild(li)
			ul.appendChild(ul_sub);
			
			li = document.createElement('Button');
			li.className = 'item prev';
			a = document.createElement('a');
			a.style.cursor = 'pointer';
			addEventHandler(li, 'click', pageMove, tp - 1, divCd);
			tt = document.createTextNode('<');
			a.appendChild(tt);
			li.appendChild(a);
			ul_sub.appendChild(li)
			ul.appendChild(ul_sub);
			}
	
			sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
			let ul_sub2 = document.createElement('DIV');
			ul_sub2.className ="group";
			for (let i = sr; i < (sr + pagecnt); i++) {
			if (i <= lastpage) {
				li = document.createElement('Button');
				li.className ="item";
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				tt = document.createTextNode(String(i));
				addEventHandler(li, 'click', pageMove, i, divCd);
				if (i === tp) {
				li.className ="item active";
				}
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub2.appendChild(li);
				ul.appendChild(ul_sub2);
			}
			}
	
			if (thispage < lastpage) {
			let ul_sub3 = document.createElement('DIV');
			ul_sub3.className ="group";	
			a = document.createElement('a');
			a.style.cursor = 'pointer';
			li = document.createElement('Button');
			li.className = 'item next';
			tt = document.createTextNode('>');
			addEventHandler(li, 'click', pageMove, tp + 1 ,divCd);
			a.appendChild(tt);
			li.appendChild(a);
			ul_sub3.appendChild(li);
			ul.appendChild(ul_sub3);
			
			li = document.createElement('Button');
			li.className = 'item last';
			tt = document.createTextNode('>>');
			a = document.createElement('a');
			a.style.cursor = 'pointer';
			addEventHandler(li, 'click', pageMove, lastpage, divCd);
			a.appendChild(tt);
			li.appendChild(a);
			ul_sub3.appendChild(li);
			ul.appendChild(ul_sub3);
			}
	
			ul.className = 'pg';
			if(divCd =="reqAmtList"){
				// @ts-ignore
				document.getElementById('pageNaviRede').appendChild(ul);
			}
	
		} catch (ex) {
			// @ts-ignore
			console.log(ex.message);
		}
		}

	//페이지 이동
	// @ts-ignore
	const pageMove = function (cPage:number, divCd:string) {
		 if(divCd =="reqAmtList"){
			// @ts-ignore
			RedeReqAmtList.goToPageByIndex(cPage);
		 }
	
	}

	//페이지 이동 이벤트 핸들러
	// @ts-ignore
	const addEventHandler = function (obj, evtName, func, param, param2) {
		if (obj.addEventListener) { // all browsers except IE before version 9
			obj.addEventListener(evtName, function () { func(param ,param2); }, false);
		} else if (obj.attachEvent) { // IE before version 9
			obj.attachEvent('on' + evtName, function () { func(param ,param2); });
		}
	}

	//날짜 0 처리 
    function dateLpad(num){
		let strNum = num;
		if(strNum.length == 1){
			strNum = "0"+strNum;
		}

		return strNum;
	}

	function dateToStr(dateText) {

		if(dateText == null) return '';

		if(/^(-?)[0-9]+$/.test(dateText)){
			dateText = Number(dateText);
		}
		let date = new Date(dateText);
		let week = new Array('일', '월', '화', '수', '목', '금', '토');


		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();
		let dayName = week[date.getDay()];

		return year+'-'+dateLpad(String(month))+'-'+dateLpad(String(day))+'('+dayName+')';
	}


	//상세정보 값 가지고 오기
	function getInfo(name, type){
		if(type =='rede'){
			if(Object.keys(redeDetail).length != 0){
				return redeDetail[name];
			}else{
				return '';
			}
		}else if(type =='pay'){
			if(Object.keys(payDetail).length != 0){
				return payDetail[name];
			}else{
				return '';
			}
		}else if(type =='tsk'){
			if(Object.keys(tskDetail).length != 0){
				return tskDetail[name];
			}else{
				return '';
			}
		}else if(type =='user'){
			if(Object.keys(memberDetail).length != 0){
				return memberDetail[name];
			}else{
				return '';
			}
		}
		
	};

	//상세정보 값 가지고 오기
	function getTskInfo(name){
		if(Object.keys(tskDetail).length != 0){
			return tskDetail[name];
		}else{
			return '';
		}

		
	};
	
	//상세정보 가지고 오기 
	async function initCall(redeReqNo, payReqNo, tskReqNo,tskReqModiSeq){
		
		let param = {
			"REDE_REQ_NO": redeReqNo
			,"PAY_REQ_NO": payReqNo
			,"TSK_REQ_NO": tskReqNo
			,"TSK_REQ_MODI_SEQ": tskReqModiSeq
		};

		const response:any = await CommonUtil.execute({
			url:'usr_2137_redeDetail',
			data: param
		})

		const result = response;
		
		setRedeDetail(result.REDE_DETAIL);   //환수정보
		setPayDetail(result.PAY_DETAIL[0]);     //지급정보
		setTskDetail(result.TSK_DETAIL);     //과제정보
		setMemberDetail(new TbComPerson(result.PERSON_INFO)); //사람정보
		setJudgeList(result.JUDGE_LIST);     //심사리스트
		setJudgeReqList(result.JUDGE_LIST.filter(x => x.REDE_REQ_STS_CD == 'C'));  //내부검토 수정요청건만 따로 
		setTrdList(result.TRD_LIST);
		setFileValue(new TbComFile(result.FILE_INFO))

		setLoadFinish(true);
		

	};

	
	

	// 환수기업목록조회 모달 modal2138Open 오픈
	async function modal2138Open() {
		// @ts-ignore
		if(IBSheet.RedeReqAmtList !==undefined){
			// @ts-ignore
			IBSheet.RedeReqAmtList.dispose();
		}
		if(payReqNo == "" || payReqNo == null){
			await UIUtils.alert("집행과제를 선택해주세요.");
			return false;
		}
		setModaladm2138Open(true)
	}


	//환수기업목록조회 모달 modaladm2138Close 닫기
	async function modaladm2138Close() {
		// @ts-ignore
		if(IBSheet.RedeReqAmtList !==undefined){
			// @ts-ignore
			IBSheet.RedeReqAmtList.dispose();
		}
		setModaladm2138Open(false);
	}

	//환수기업목록조회 모달 onAfterModaladm2138Open IBSheet오픈 
	async function onAfterModaladm2138Open() {
		// @ts-ignore
		if(IBSheet.RedeReqAmtList !==undefined){
			// @ts-ignore
			IBSheet.RedeReqAmtList.dispose();
		}
		ib.createRedeReqAmtList();
    }

	//환수기업 내역조회
	async function getRedeReqAmtList(sAction:string) {
		if(payReqNo == "" || payReqNo == null){
			await UIUtils.alert("집행과제를 선택해주세요.");
			return;
		}

		
		let param = {
			"PAY_REQ_NO" : payReqNo,
			"REDE_REQ_NO" : redeReqNo
		}
		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'usr_2136_selectRedeReqAmtSaveList',
			data: param
		})

		//전체데이터
		let result = response.LIST;

		//전체ROW개수
		totalRedeReqAmtListCnt = Object.keys(result).length;
		setTotalRedeReqAmtListCnt(Object.keys(result).length);

		//데이터 처리
		ib.redeReqAmtListPopData = result;
		// @ts-ignore
		RedeReqAmtList.loadSearchData(result);  //data 로딩 처리
		
		
		// @ts-ignore
		RedeReqAmtList.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		// @ts-ignore
		//makePageIndex(RedeReqAmtList.getPageIndex( RedeReqAmtList.getFocusedPage()) + 1, "reqAmtList"); // 페이지 초기화

	}

	
	//목록으로 
	const goList = () =>{
		history.push({
			pathname: './usr_2133',  
			state: { data: receivedData }
		});
	}

	function buttonHandler(action){

		//싱테깂 신청	A ,접수중	B, 수정요청	C , 최종접수	F,	환수완료	G
		if(action == 'U'){ // 제출
		 	updateSub();
		} else if(action == 'D'){ // 삭제
			deleteRedeReq();
		} else if(action == 'C'){ // 최종접수
			//lastSubmitRedeReq();
		} else if(action == 'M'){ // 수정
			let vREDE_REQ_NO = redeReqNo;
			let vPAY_REQ_NO = payReqNo;
			let vTSK_REQ_NO = tskReqNo;
			let vTSK_REQ_MODI_SEQ = tskReqModiSeq;

			let dataToSend = {vREDE_REQ_NO, vPAY_REQ_NO, vTSK_REQ_NO,vTSK_REQ_MODI_SEQ};

			// 다른 페이지로 이동하면서 데이터 전달
			history.push({
				pathname: './usr_2138',
				state: { data: dataToSend }
			});
		} 
		
	}

	//환수신청 제출
	async function updateSub(){ 
        if(fileValue.tbComFileMapngDetailList.length == 0){
			await UIUtils.alert(<>필수서류가 누락되었습니다.<br/> 파일첨부 후 제출해 주세요.</>);
			return;
		}
		
		if(await UIUtils.confirm('제출하시겠습니까?')){
			let param = {
				"REDE_REQ_NO" : redeReqNo
			}
			//파라미터 전송
			const response:any = await CommonUtil.execute({
				url:'usr_2137_updateSub',
				data: param
			}).catch(err => {
				CommonUtil.showAxiosError(err);
				return;
			});

			if(response){
				await UIUtils.alert("제출되었습니다.").then(()=>{
					goList();	
				})
			}
		}

	}

	//환수신청 삭제
	async function deleteRedeReq(){
        if(await UIUtils.confirm(message.get("common.message.delete.confirm", "삭제하시겠습니까?"))){
			let param = {
				"REDE_REQ_NO" : redeReqNo,
				"FILE_ID" : getInfo('FILE_ID','rede')
			}
			//파라미터 전송
			const response:any = await CommonUtil.execute({
				url:'usr_2137_deleteRedeReq',
				data: param
			}).catch(err => {
				CommonUtil.showAxiosError(err);
				return;
			});

			if(response){
				await UIUtils.alert("삭제되었습니다.").then(()=>{
					goList();	
				})
			}
		}
	}

	//은행명 가지고 오기 
	const getBankNm =(bankCd:string)=>{
    	return codeDataStore.getCodeName("[BANK]", bankCd);
    } 

	 //상세페이지 로딩시 해야할 것
	//비밀번호 오류횟수 , 권한등록 ,사업지정 , 출엽기업 승인, 이메일 인증발송
	React.useEffect(() => {

		codeDataStore.read("[BANK]").then();
		//필요한 공통코드 로딩.
		//codeDataStore.read("[RRSC]", "[DCDC]", "[FPUC]", "[SGC]", "[JUDC]", "[BKC1]", "[BKC2]", "[BANK]")
		//	.then(() => {

			if(receivedData != undefined){
				
				let vRedeReqNo = StringUtil.defaultString(receivedData.vREDE_REQ_NO);
				let vPayReqNo = StringUtil.defaultString(receivedData.vPAY_REQ_NO);
				let vTskReqNo = StringUtil.defaultString(receivedData.vTSK_REQ_NO);
				let vTskReqModiSeq = StringUtil.defaultString(receivedData.vTSK_REQ_MODI_SEQ);

				setRedeReqNo(vRedeReqNo);
				setPayReqNo(vPayReqNo);
				setTskReqNo(vTskReqNo);
				setTskReqModiSeq(vTskReqModiSeq);
		
				
				initCall(vRedeReqNo, vPayReqNo,vTskReqNo,vTskReqModiSeq).then();
			}

		
    },[])

	// if(!loadFinish)
	// 	return (
	// 		<PageLoading />
	// 	)
	// else
	//})
	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={2} lnbIdx={4}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">환수신청 상세</h1>
					{/* <div className="hz-root hz-right hz-gap10 mb30">
						<Button color="pri" size="md">제출</Button>
						<Button color="pri-o" size="md" href="/main/usr_2100/usr_2138">수정</Button>
						<Button color="gray-o" size="md">삭제</Button>
						<Button color="gray-o" size="md" href="/main/usr_2100/usr_2133">목록</Button>
					</div> */}
					
					{/*환수 신청 내용 */}
					<section className="fund-section">
						<h3 className="section-title mb15">환수 신청 내용</h3>
						<div className="fo fo-col2" >
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">환수신청번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={getInfo('REDE_REQ_NO','rede')} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">진행상태</p>
									<div className="fo-value">
										<UI.If test ={getInfo('REDE_REQ_STS_CD','rede') == "A"}>
											<span className="badge badge-22 blue">신청</span>
										</UI.If>
										<UI.If test ={getInfo('REDE_REQ_STS_CD','rede') == "F"}>
											<span className="badge badge-22 green">최종접수</span>
										</UI.If>
										<UI.If test ={getInfo('REDE_REQ_STS_CD','rede') == "C"}>
											<span className="badge badge-22 yellow">수정요청</span>
										</UI.If>
										<UI.If test ={getInfo('REDE_REQ_STS_CD','rede') == "B"}>
											<span className="badge badge-22 skyblue">접수중</span>
										</UI.If>
										{/* <UI.If test ={getInfo('REDE_REQ_STS_CD','rede') == "D"}>
											<span className="badge badge-22 skyblue">반려</span>
										</UI.If>
										<UI.If test ={getInfo('REDE_REQ_STS_CD','rede') == "E"}>
											<span className="badge badge-22 skyblue">입금확인</span>
										</UI.If> 
										<UI.If test ={getInfo('REDE_REQ_STS_CD','rede') == "H"}>
											<span className="badge badge-22 skyblue">지출결의중</span>
										</UI.If>
										*/}
										<UI.If test ={getInfo('REDE_REQ_STS_CD','rede') == "G"}>
											<span className="badge badge-22 black">환수완료</span>
										</UI.If>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">환수 신청일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={dateToStr(getInfo('REDE_REQ_DATE','rede'))} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">환수완료일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={dateToStr(getInfo('REDE_COMPL_DATE','rede'))} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">환수 금액</p>
									<div className="fo-value">
										<div className="tf-unit hz-item w100p">
											<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(getInfo('REDE_AMT','rede'), 0)} placeholder={''} readOnly={true}/>
											<span className="u">원</span>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">환수 기업수</p>
									<div className="fo-value">
										<div className="hz-root hz-sb w100p">
											<div className="hz-root hz-gap5 ">
												<UIInput className={'tf tf-md  hz-item hz-fg'} value={getInfo('REDE_CORP_CNT','rede') +' 개사'} placeholder={''}  readOnly={true}/>	
												{/* <p className="tx-msg hz-item">개사</p> */}
											</div>
											<Button color='gray-o' size="md" onClick={modal2138Open}>환수기업내역</Button> 
										</div>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">제출여부</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={getInfo('SUB_YN','rede')=='Y'?'예':'아니오'} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">환수계좌</p>
									<div className="fo-value">
										<UI.If test ={getInfo('ACCT_NO_DES','rede') != null}>
											<UIInput className={'tf tf-md w100p'} value={getInfo('ACCT_NO_DES','rede') +' ('+ getBankNm(getInfo('BANK_CD','rede'))+')'} placeholder={''} readOnly={true} />
									    </UI.If>
									</div>
								</div>
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">환수 사유</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={getInfo('REDE_REASON','rede')} placeholder={''} readOnly={true} />
									</div>
								</div>
							
							</div>
						</div>
					</section>

					{/* 환수 입금내역 및 면제부 금액 */}
					<UI.If test ={getInfo('REDE_REQ_STS_CD','rede') == "F" || getInfo('REDE_REQ_STS_CD','rede') == "G"}>
					<section className="fund-section">
						<div className="hz-root hz-sb mb15">
							<h3 className="section-title hz-item">환수 입금내역 및 환수면제 금액</h3>
						</div>

						<div>
							<div className="tb tb-narrow mb15">
								<table>
									<caption></caption>
									<colgroup>
										<col width="90px" />
										<col width="230px" />
										<col width="120px" />
										<col />
										{/* <col width="230px" /> */}
										<col width="120px" />
										<col width="230px" />
									</colgroup>
									<thead>
										<tr>
											<th scope="col">순번</th>
											<th scope="col">거래일시</th>
											<th scope="col">계좌구분</th>
											<th scope="col">가상계좌</th>
											{/* <th scope="col">지원금액(원)</th> */}
											<th scope="col">입금의뢰인</th>
											<th scope="col">입금금액(원)</th>
										</tr>
									</thead>
									<tbody>

										{
											trdList.length != 0 ? trdList.map((trdInfo, idx) => (
													<tr key={idx}>
														<td className="ta-center">{idx+1}</td>
														<td><UIInput className={'tf ta-center tf-md w100p'} value={trdInfo.ACCT_DAYTIME} placeholder={''} readOnly={true} /></td>
														<td><UIInput className={'tf ta-center tf-md w100p'} value={trdInfo.ACCT_TYPE_DISP} placeholder={''} readOnly={true} /></td>
														<td><UIInput className={'tf tf-md w100p'} value={trdInfo.VACCT_NO_DISP} placeholder={''} readOnly={true} /></td>
														{/* <td>
															<div className="tf-unit hz-item w100p">
																<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(trdInfo.PAY_AMT, 0)}  placeholder={''} readOnly={true}/>
																<span className="u">원</span>
															</div>
														</td> */}
														<td><UIInput className={'tf ta-center tf-md w100p'} value={memberDetail.personNm} placeholder={''} readOnly={true} /></td>
														<td>
															<div className="tf-unit hz-item w100p">
																<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(trdInfo.IN_AMT, 0)} placeholder={''} readOnly={true}/>
																<span className="u">원</span>
															</div>
														</td>
									
													</tr>
												)) :
												<tr>
													<td colSpan={7}>
														<div className="nd">
															<p className="tx tx-cp2 fc-666">입금된 내역이 없습니다.</p>
														</div>
													</td>
												</tr>
										}
										
									</tbody>
								</table>
							</div>
							<UI.If test ={Number(getInfo('EXEMP_AMT','rede')) > 0 }>
								<div className="fo fo-col2">
									<div className="inner">
										<div className="fo-item fo-m-1-3">
											<div className="fo-key">총 환수 면제 금액</div>
											<div className="fo-value">
												<div className="hz-root hz-gap5 w100p">
													<div className="tf-unit hz-item hz-fg">
														<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(getInfo('EXEMP_AMT','rede')))} placeholder={''} readOnly={true}/>
														<span className="u">원</span>
													</div>
													<UI.If test ={Number(getInfo('EXEMP_AMT','rede')) > 0}>
														<div className="hz-item tx-msg">
															<span className="fc-pri">
															({StringUtil.isNotEmpty(Number(getInfo('EXEMP_AMT','rede')) + "") ?
																StringUtil.numberToKorean(Number(getInfo('EXEMP_AMT','rede'))) + " 원" : "원"})
															</span></div>
												    </UI.If>
												</div>
											</div>
										</div>
										{/*<div className="fo-item fo-m-1-3">
											<div className="fo-key">면제부 사유</div>
											<div className="fo-value">
												<div className="ta-group w100p">
													<UITextArea className="ta-ip" value={getInfo('EXEMP_REASON','rede')} attrs={{ rows: 3 , readOnly:true}}/>
												</div>
											</div>
										</div>*/}
									</div>
								</div>
							</UI.If>
						</div>
					</section>
					</UI.If>

					{/* 과제 지급 내용  */}
					<section className="fund-section">
						<h3 className="section-title mb15">과제 지급 내용</h3>
						<div className="fo fo-col2">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">지급신청번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={getInfo('PAY_REQ_NO','pay')} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">과제신청번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={StringUtil.tskReqNoFormat(getInfo('TSK_REQ_NO','tsk'))} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item fo-m-1-3">
									<div className="fo-key">과제명</div>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={getInfo('TSK_NM','tsk')} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item ">
									<div className="fo-key">과제기간</div>
									<div className="fo-value">
										<div className="hz-root hz-left hz-gap5">
											<UIInput className={'w280 hz-fg tf tf-md'} value={dateToStr(getInfo('TSK_ST_DATE','tsk')) +'~'+ dateToStr(getInfo('TSK_EN_DATE','tsk')) } placeholder={''} readOnly={true} />
											<div className="hz-item tx-msg">({getInfo('TSK_PERIOD','tsk')})</div>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">집행금액(원)</p>
									<div className="fo-value">
										<div className="hz-root hz-gap5 w100p">
											<div className="tf-unit hz-item hz-fg">
												<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(getInfo('PAY_AMT','pay')))} placeholder={''} readOnly={true}/>
												<span className="u">원</span>
											</div>
											<div className="hz-item tx-msg"><span className="fc-pri"> ({StringUtil.isNotEmpty(getInfo('PAY_AMT','pay') + "") ?
													StringUtil.numberToKorean(Number(getInfo('PAY_AMT','pay'))) + " 원" : "원"})</span></div>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">사업분류</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={getInfo('BIZ_NM','tsk')} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<div className="fo-key">기금사용용도</div>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={getInfo('FUN_PUR_USE_NM','tsk')} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">과제분야(대분류)</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={getInfo('BIZ_KIND_NM1','tsk')} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">과제분야(소분류)</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={getInfo('BIZ_KIND_NM2','tsk')} placeholder={''} readOnly={true} />
									</div>
								</div>
							</div>
						</div>
					</section>

					{/* 지원대상 */}
					<section className="fund-section">
						<h3 className="section-title mb15">지원 대상</h3>
						<div className="fo fo-col2">
							<div className="inner">
								<div className="fo-item">
									<div className="fo-key">중소기업 지원 수</div>
									<div className="fo-value">
										<div className="hz-root hz-gap5 ">
											<UIInput className={'tf tf-md ta-right hz-item hz-fg'} value={getInfo('SUPP_CORP_CNT','pay')} placeholder={''}  readOnly={true}/>	
											<p className="tx-msg hz-item">개사</p>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<div className="fo-key">중소기업 외 지원 수</div>
									<div className="fo-value">
										<div className="hz-root hz-gap5 ">
											<UIInput className={'tf tf-md ta-right hz-item hz-fg'} value={getInfo('OTHER_SUPP_CORP_CNT','tsk')} placeholder={''}  readOnly={true}/>	
											<p className="tx-msg hz-item">개사</p>
										</div>
									</div>
								</div>
								<UI.If test ={getInfo('PERF_CORP','pay') != ''}>
								<div className="fo-item fo-m-1-3">
									<div className="fo-key">수행기관</div>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={getInfo('PERF_CORP','pay')} placeholder={''} readOnly={true} />
									</div>
								</div>
								</UI.If>
							</div>
						</div>
					</section>


					{/* 첨부파일 */}
					<section className="fund-section">
						<div className="hz-root hz-sb mb15">
							<h3 className="section-title">첨부파일</h3>
							{/* <Button color='gray-o' size="sm">첨부파일수정</Button>  */}
						</div>
						<div className="fo fo-col2" >
							<div className="inner">
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">환수 신청서</p>
									<div className="fo-value ">
										<div className="fund-form-group">
											<div className="fund-form-items">
													<UI.FileDownload value={fileValue} className={'w100p'}/>
											</div>
											{/* <Button color='gray-o' size="md">미리보기</Button> */}
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>


					{/* 내부검토사항 */}
					{/* <UI.If test={judgeReqList.length != 0}>
					<section className="fund-section">
						<h3 className="section-title hz-item mb15">내부검토사항</h3>
						<div>
							<div className="tb tb-narrow">
								<table>
									<caption></caption>
									<colgroup>
										<col width="90px" />
										<col />
										<col width="230px" />
									</colgroup>
									<thead>
										<tr>
											<th scope="col">순번</th>
											<th scope="col">반려사유</th>
											<th scope="col">담당자명</th>
										</tr>
									</thead>
									<tbody>
									{
										judgeReqList.length != 0 ? judgeReqList.map((judge, idx) => (
												<tr key={idx}>
													<td>{idx + 1}</td>
													<td>{
														judge.JUDGE_CMT.split('\n').map((cmt) => {
															return (
																<span>
																{cmt}
																<br/>
														  </span>
															);
														})
													}</td>
													<td>{judge.REG_USERNM}</td>
												</tr>
											)) :
											<tr>
												<td colSpan={3}>
													<div className="nd">
														<p className="tx tx-cp2 fc-666">내역이 없습니다.</p>
													</div>
												</td>
											</tr>
									}
									</tbody>
								</table>
							</div>
						</div>
					</section>
					</UI.If> */}

					{/* 심사 의견 */}
					<UI.If test={judgeList.length != 0}>
					<section className="fund-section">
						<h3 className="section-title hz-item mb15">심사 의견</h3>
						<div>
							<div className="tb tb-narrow">
								<table>
									<caption></caption>
									<colgroup>
										<col width="90px" />
										<col width="230px" />
										{/* <col width="230px" /> */}
										<col />
										<col width="130px" />
										<col width="230px" />
									</colgroup>
									<thead>
										<tr>
											<th scope="col">순번</th>
											<th scope="col">심사진행상태</th>
											{/* <th scope="col">심사일시</th> */}
											<th scope="col">심사의견</th>
											<th scope="col">담당자명</th>
											<th scope="col">담당자 수정일시</th>
										</tr>
									</thead>
									<tbody>
									{
										judgeList.length != 0 ? judgeList.map((judge, idx) => (
												<tr key={idx}>
													<td>{idx + 1}</td>
													<td>{judge.REDE_REQ_STS_NM}</td>
													{/* <td>{judge.JUDGE_DATE}</td> */}
													<td>{
														judge.JUDGE_CMT.split('\n').map((cmt) => {
															return (
																<span>
																{cmt}
																<br/>
														  </span>
															);
														})
													}</td>
													<td>{judge.MODI_USERNM}</td>
													<td>{DateUtils.toDateFormat(judge.MODI_DATE,'YYYY-MM-DD HH:mm:ss')}</td>
												</tr>
											)) :
											<tr>
												<td colSpan={4}>
													<div className="nd">
														{/* <i className="ic"></i> */} {/* [M.20240522]삭제 */}
														<p className="tx tx-cp2 fc-666">내역이 없습니다.</p>
													</div>
												</td>
											</tr>
									}
									</tbody>
								</table>
							</div>
						</div>
					</section>
					</UI.If>

					{/* 기업정보 */}
					<section className="fund-section">
						<h3 className="section-title mb15">기업 정보</h3>
						<div className="fo fo-col2">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">기업명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={memberDetail.corpNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">법인사업자번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={memberDetail.corpRegNo} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">사업자번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={StringUtil.bizCrpFormat(memberDetail.bizNo)} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">담당자</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={memberDetail.personNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">직급</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={memberDetail.posiNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">부서</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={memberDetail.deptNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">이메일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={memberDetail.emailAdres} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">전화번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={memberDetail.ofcTelNo} placeholder={''} readOnly={true} />
									</div>
								</div>
							</div>
						</div>
					</section>
					{/*버튼목록*/}
					{/*
					신청	A
					접수중	B
					수정요청	C
					최종접수	F
					환수완료	G
					*/}
					<div className="hz-root hz-right hz-gap10 mt30">
					   <UI.If test = {getInfo('SUB_YN','rede') !== "Y" && (getInfo('REDE_REQ_STS_CD','rede') === "A" || getInfo('REDE_REQ_STS_CD','rede') === "B" || getInfo('REDE_REQ_STS_CD','rede') === "C")}>
							<div className="hz-root hz-right hz-gap10 mt30">
								<Button color="pri" size="md" onClick={() => buttonHandler('U')}>제출</Button>
								<Button color="pri-o2" size="md" onClick={() => buttonHandler('M')}>수정</Button>
								<Button color="gray-o" size="md" onClick={() => buttonHandler('D')}>삭제</Button>
								<Button color="gray-o" size="md" onClick={goList}>목록</Button>
							</div>
						</UI.If>
						<UI.If test = {getInfo('SUB_YN','rede') === "Y"}>
							<div className="hz-root hz-right hz-gap10 mt30">
								<Button color="gray-o" size="md" onClick={goList}>목록</Button>
							</div>
						</UI.If>
					</div>
				</main>
			</div>
			{/* modal - 환수기업 내역등록 */}
			<ModalPopup
				open={modaladm2138Open}
				title="환수기업 내역등록"
				size="lg"
				onClose={() => modaladm2138Close()}
				onAfterOpen={() => onAfterModaladm2138Open()}
			   >
				<div className="modal-con">
					<div className="fo fo-col2 mb30">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">지원 금액 합계(원)</p>
								<div className="fo-value">
									<div className="tf-unit hz-item w100p">
										<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(payAmtSum)} valueChanged={(value) => setPayAmtSum(value)} placeholder={''} readOnly={true}/>
										<span className="u">원</span>
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">환수금액 합계(원)</p>
								<div className="fo-value">
									<div className="tf-unit hz-item w100p">
										<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(redeAmtSum)} valueChanged={(value) => setRedeAmtSum(value)} placeholder={''} readOnly={true}/>
										<span className="u">원</span>
									</div>
								</div>
							</div>
							<UI.If test ={Number(getInfo('EXEMP_AMT','rede')) > 0}>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">총 환수 면제 금액(원)</p>
								<div className="fo-value">
									<div className="tf-unit hz-item w100p">
										<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(getInfo('EXEMP_AMT','rede')))} placeholder={''} readOnly={true}/>
										<span className="u">원</span>
									</div>
								</div>
							</div>
							</UI.If>
						</div>
					</div>
					<div className="tb-top">
						<div>
							<p className="tx fc-black">총 <em className="fw500">{totalReqAmtListCnt}</em>건</p>
						</div>
					
					</div>
					
					<div className="ibsheet" id='RedeReqAmtListDiv'>
						<p style={{height:"300px"}}>[D] IBSHEET 영역</p>
					</div>
					<div id="pageNaviRede" className="pg"></div>
				</div> 
				<div className="modal-bottom">
					{/* <Button color="gray-o" size="md" onClick={modaladm2138Close}>취소</Button>
					<Button color="pri" size="md" onClick={modaladm2138Save}>저장</Button> */}
				</div>
			</ModalPopup>
		</PageContainer>
	);
}
export default ContentsContainer;


